import {
  Avatar,
  Button,
  createStyles,
  Fab,
  FormControl,
  Grid,
  Hidden,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  MenuItem,
  Select,
  TableBody,
  TableContainer,
  TableHead,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Skeleton from "@material-ui/lab/Skeleton";
import { css } from "emotion";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import {
  StyledTable,
  StyledTableCell,
  StyledTableRow,
} from "../../components/CustomStyles/CustomTable";
import Img from "../../components/Img";
import InputSearch from "../../components/InputSearch/InputSearch";
import { formatCurrency } from "../../components/Utils/Currency";
import { capitalize } from "../../Helpers/string";
import propertyStore from "../../Store/PropertyStore";
import { showDetail } from "./parts/detail";
import { showForm } from "./parts/form";
import { BootstrapInput } from "../../components/CustomStyles/CustomInput";
import History from "../../History/History";

const user = JSON.parse(localStorage.getItem("user"));
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    button: {
      margin: 0,
      maxHeight: 30,
      padding: 1,
    },
    paper: {
      padding: 8,
      width: 290,
    },
    demo1: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 10,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    table: {
      minWidth: 650,
    },
    card: {
      margin: 5,
      width: "300px",
    },
    cardTitle: {
      color: theme.palette.primary.dark,
      fontWeight: "bolder",
    },
    cardSubHeader: {
      fontSize: "smaller",
    },
  })
);

const PropertyList = (props) => {
  const classes = useStyles();
  const { data, showDetail } = props;

  return (
    <StyledTableRow>
      <StyledTableCell align="left">
        <List style={{ padding: 0 }}>
          <ListItem style={{ padding: 0 }}>
            <ListItemAvatar>
              <Avatar
                variant="rounded"
                style={{ boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.15)" }}
              >
                <Img src={data.logo.square} width={40} height={40} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography
                  color="primary"
                  style={{ fontWeight: "bolder", fontSize: 13 }}
                >
                  {data.name}
                </Typography>
              }
              secondary={
                <span style={{ fontWeight: "bolder", fontSize: 11 }}>
                  0 tenant users
                </span>
              }
            />
          </ListItem>
        </List>
      </StyledTableCell>
      <StyledTableCell align="left">
        <Typography
          color="textPrimary"
          style={{ fontWeight: "bolder", fontSize: 12 }}
        >
          {capitalize(data.type)}
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="left">
        <Typography
          color="textPrimary"
          style={{ fontWeight: "bolder", fontSize: 12 }}
        >
          {data.parent.name}
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="left">
        <Typography color="secondary" style={{ fontSize: 12 }}>
          {data.email}
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="left">
        <Typography color="textPrimary" style={{ fontSize: 12 }}>
          {data.fee.percent > 0
            ? formatCurrency(
                process.env.REACT_APP_CURRENCY_CODE,
                data.fee.percent,
                true
              ) + "%"
            : data.fee.amount > 0
            ? formatCurrency(
                process.env.REACT_APP_CURRENCY_CODE,
                data.fee.amount
              ) + "/trx"
            : "-"}
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="right">
        <IconButton
          color="secondary"
          aria-label="detail property"
          onClick={showDetail}
        >
          <ArrowForwardIcon />
        </IconButton>
      </StyledTableCell>
    </StyledTableRow>
  );
};

const Property = (props) => {
  const { params } = props;
  const classes = useStyles();
  const [search, setSearch] = React.useState("");
  const [propertyType, setPropertyType] = React.useState("");
  const [propertyState, propertyActions] = propertyStore();
  let perPage = 10;

  const handleGetPropertyList = (refresh) => {
    var query = {
      num: perPage.toString(),
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      type: propertyType || "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      cursor: refresh ? "" : propertyState.header["x-cursor"] || "",
      keyword: search,
    };
    propertyActions.getList(query, refresh);
  };

  const handleSearch = async (e) => {
    setSearch(e.target.value);
  };

  const handleFilterType = async (e) => {
    setPropertyType(e.target.value);
  };

  const handleShowForm = (value) => {
    if (value === null) {
      showForm("Input Property", value, handleGetPropertyList).then(
        (process) => {
          // handleActions(value);
        },
        (cancel) => {
          // setUpdate(!update);
        }
      );
    } else {
      showForm("Edit Property", value, handleGetPropertyList).then(
        (process) => {
          // handleActions(value);
        },
        (cancel) => {
          // setUpdate(!update);
        }
      );
    }
  };

  const handleShowDetail = (value) => {
    showDetail(
      "Detail Property",
      value,
      props.params,
      handleShowForm,
      handleGetPropertyList
    ).then(
      (process) => {
        handleShowForm(value);
      },
      (cancel) => {
        // setUpdate(!update);
      }
    );
  };

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      const refresh = true;
      handleGetPropertyList(refresh);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search, propertyType]);

  return (
    <BaseLayout>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <h3>Property / List Property</h3>
        </Grid>
      </Grid>
      <Grid container className={classes.root}>
        <Hidden
          smUp
          implementation="css"
          className={css`
            width: 100%;
          `}
        >
          <Grid
            item
            container
            direction="column"
            alignItems="flex-start"
            justify="flex-start"
            xs={12}
            style={{ marginBottom: 10 }}
          >
            <InputSearch
              value={search}
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder="Search Property"
              style={{ width: "100% !important" }}
            />
            <FormControl style={{ margin: "12px 0px", minWidth: "100%" }}>
              <Select
                displayEmpty
                value={propertyType}
                onChange={handleFilterType}
                label="Type"
                inputProps={{
                  name: "type",
                  id: "outlined-type-native-simple",
                }}
                input={<BootstrapInput />}
              >
                <MenuItem value="">
                  <em>Semua Property Type</em>
                </MenuItem>
                {user?.operational?.level === 3 && (
                  <MenuItem value="brand">Brand</MenuItem>
                )}
                <MenuItem value="mall">Mall</MenuItem>
                <MenuItem value="hotel">Hotel</MenuItem>
                <MenuItem value="residential">Residential</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Hidden>
        <Hidden
          xsDown
          implementation="css"
          className={css`
            width: 100%;
          `}
        >
          <Grid
            item
            container
            direction="row"
            alignItems="center"
            justify="flex-start"
            xs={12}
            style={{ marginBottom: 10 }}
          >
            <InputSearch
              value={search}
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder="Search Property"
            />
            <FormControl style={{ margin: "0px 12px" }}>
              <Select
                displayEmpty
                value={propertyType}
                onChange={handleFilterType}
                label="Type"
                inputProps={{
                  name: "type",
                  id: "outlined-type-native-simple",
                }}
                input={<BootstrapInput />}
              >
                <MenuItem value="">
                  <em>Semua Property Type</em>
                </MenuItem>
                {user?.operational?.level === 3 && (
                  <MenuItem value="brand">Brand</MenuItem>
                )}
                <MenuItem value="mall">Mall</MenuItem>
                <MenuItem value="hotel">Hotel</MenuItem>
                <MenuItem value="residential">Residential</MenuItem>
              </Select>
            </FormControl>
            <Hidden
              xsDown
              implementation="css"
              className={css`
                margin-left: auto !important;
              `}
            >
              {props.params.create && (
                <Tooltip
                  title="add property"
                  aria-label="add"
                  arrow
                  placement="bottom"
                >
                  <Button
                    onClick={() => {
                      History.push("/property/add");
                    }}
                    color="secondary"
                    variant="contained"
                  >
                    <Add style={{ marginRight: "0.5rem" }} /> Add
                  </Button>
                </Tooltip>
              )}
            </Hidden>
          </Grid>
        </Hidden>

        <Grid item xs={12}>
          <TableContainer>
            <StyledTable>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left">Property</StyledTableCell>
                  <StyledTableCell align="left">Type</StyledTableCell>
                  <StyledTableCell align="left">Brand</StyledTableCell>
                  <StyledTableCell align="left">Email</StyledTableCell>
                  <StyledTableCell align="left">Fee</StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {propertyState.isLoading &&
                  Array.from(new Array(5)).map((row, key) => {
                    return (
                      <StyledTableRow key={key}>
                        <StyledTableCell align="left">
                          <List style={{ padding: 0 }}>
                            <ListItem style={{ padding: 0 }}>
                              <ListItemAvatar>
                                <Skeleton
                                  variant="rect"
                                  width={40}
                                  height={40}
                                />
                              </ListItemAvatar>
                              <ListItemText
                                primary={<Skeleton variant="text" width={90} />}
                                secondary={
                                  <Skeleton variant="text" width={85} />
                                }
                              />
                            </ListItem>
                          </List>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Skeleton variant="text" width={120} />
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Skeleton variant="text" width={120} />
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Skeleton variant="text" width={120} />
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Skeleton variant="text" width={120} />
                        </StyledTableCell>
                        <StyledTableCell align="right"></StyledTableCell>
                      </StyledTableRow>
                    );
                  })}

                {!propertyState.isLoading &&
                  propertyState.data.map((property) => {
                    return (
                      <PropertyList
                        key={property.id}
                        data={property}
                        showDetail={() => handleShowDetail(property)}
                      />
                    );
                  })}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </Grid>

        {!propertyState.isLoading && propertyState.data.length === 0 && (
          <Grid item xs={12}>
            <div className={classes.demo1}>
              <Grid
                item
                xs
                container
                justify="center"
                style={{ margin: 10, padding: 12 }}
              >
                <span>No Data</span>
              </Grid>
            </div>
          </Grid>
        )}
        {propertyState.data.length >= perPage && (
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{ padding: "10px" }}
          >
            {propertyState.lastPage ? (
              <h2>~</h2>
            ) : (
              <Button
                onClick={() => handleGetPropertyList(false)}
                size="small"
                color="secondary"
                variant="contained"
                disabled={propertyState.isLoading}
              >
                {propertyState.isLoading ? "Please Wait" : "Load More"}
              </Button>
            )}
          </Grid>
        )}
        <Hidden smUp implementation="css">
          {props.params.create && (
            <Tooltip
              title="add property"
              aria-label="add"
              arrow
              placement="left"
            >
              <Fab
                aria-label="Add"
                classes={{ root: "FabMobile" }}
                className={classes.fab}
                color="primary"
                onClick={() => handleShowForm(null)}
              >
                <Add />
              </Fab>
            </Tooltip>
          )}
        </Hidden>
      </Grid>
    </BaseLayout>
  );
};

export default Property;
